import useCurrentUserRole from '@/features/authentication/current-user/useCurrentUserRole';
import { UserRole } from '@/features/users/models/users';
import ApiResultStatus from '@/shared/api/api-result/ApiResultStatus';

export function useWithRoleAccessCheck() {
  const currentUserRole = useCurrentUserRole();

  return async <T extends (...args: any[]) => Promise<unknown>>(
    apiFunction: T,
    ...args: Parameters<T>
  ): Promise<Awaited<ReturnType<T>>> => {
    if (currentUserRole.value === UserRole.USER) {
      return {
        errorMessage: 'Permission denied',
        status: ApiResultStatus.ERROR,
      } as Awaited<ReturnType<T>>;
    }
    return (await apiFunction(...args)) as Awaited<ReturnType<T>>;
  };
}
